
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M36.484 4.766H3.516c-.542 0-1.048.133-1.507.352L19.922 23.03l4.015-3.858L37.992 5.117a3.475 3.475 0 00-1.507-.352zM39.648 6.776L26.423 20.001l13.225 13.225c.219-.459.352-.965.352-1.506V8.282c0-.54-.133-1.047-.352-1.506zM.352 6.775C.133 7.234 0 7.74 0 8.282v23.437c0 .54.133 1.048.352 1.506L13.577 20 .352 6.775z","fill":"#fff"}}),_c('path',{attrs:{"d":"M24.766 21.657l-4.015 3.86a1.168 1.168 0 01-1.658 0l-3.859-3.86L2.01 34.882c.458.22.965.352 1.507.352h32.968c.542 0 1.048-.133 1.507-.352L24.766 21.657z","fill":"#fff"}})])
          )
        }
      }
    